import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const create = (userId, subscription) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: subscription,
  };

  return axiosInstance
    .post(`/users/${userId}/subscriptions`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const update = (userId, subscription) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: _.omit(subscription, ['id']),
  };

  const url = userId
    ? `/users/${userId}/subscriptions/${subscription.id}`
    : `/subscriptions/${subscription.id}`;
  return axiosInstance
    .patch(url, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const _delete = (userId, subscriptionId) => {
  return axiosInstance
    .delete(`/users/${userId}/subscriptions/${subscriptionId}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const findAll = (userId, query) => {
  const url = userId ? `/users/${userId}/subscriptions` : '/subscriptions';
  return axiosInstance
    .get(url, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401 && !response.config.url.includes('/users/login')) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;
    const name = data && data.name;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error, name };
  }

  return data;
};

export const subscriptionService = {
  create,
  update,
  _delete,
  findAll,
};
